"use strict";

var curry = require("../Strict/curry.js");

var identity = require('../Strict/identity.js');

var intersectionByL = require('./intersectionByL.js');

module.exports = curry(function intersectionL(a, b) {
  return intersectionByL(identity, a, b);
});